import React, { useEffect } from 'react';
import { StyleSheet, View, Text, FlatList, ActivityIndicator, TouchableOpacity } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import { fetchMissions } from '../store/slices/missionSlice';
import MissionCard from '../components/missions/MissionCard';

const MissionListScreen = () => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { missions, isLoading, error } = useSelector(state => state.missions);

  // Cargar misiones cuando se monta el componente y cuando se enfoca la pantalla
  useEffect(() => {
    dispatch(fetchMissions());
    
    // También recargar cuando la pantalla recibe el foco
    const unsubscribe = navigation.addListener('focus', () => {
      console.log('MissionListScreen recibió el foco, recargando misiones');
      dispatch(fetchMissions());
    });
    
    return unsubscribe;
  }, [dispatch, navigation]);

  const handleMissionPress = (mission) => {
    // Navegar directamente a la pestaña de detalle de misión
    navigation.navigate('MissionDetailTab', {
      screen: 'MissionDetail',
      params: { missionId: mission.id }
    });
  };

  const renderItem = ({ item }) => (
    <MissionCard 
      mission={item} 
      onPress={() => handleMissionPress(item)} 
    />
  );

  if (isLoading && missions.length === 0) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#2c3e50" />
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.centered}>
        <Text style={styles.errorText}>{error}</Text>
        <TouchableOpacity 
          style={styles.retryButton}
          onPress={() => dispatch(fetchMissions())}
        >
          <Text style={styles.retryButtonText}>Reintentar</Text>
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {isLoading && (
        <View style={styles.loadingOverlay}>
          <ActivityIndicator size="small" color="#2c3e50" />
        </View>
      )}
      
      <FlatList
        data={missions}
        keyExtractor={(item) => item.id.toString()}
        renderItem={renderItem}
        contentContainerStyle={styles.listContent}
        ListEmptyComponent={
          <View style={styles.emptyContainer}>
            <Text style={styles.emptyText}>No hay misiones disponibles</Text>
          </View>
        }
        refreshing={isLoading}
        onRefresh={() => dispatch(fetchMissions())}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorText: {
    color: '#e74c3c',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#2c3e50',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  retryButtonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  listContent: {
    padding: 15,
  },
  emptyContainer: {
    padding: 20,
    alignItems: 'center',
  },
  emptyText: {
    fontSize: 16,
    color: '#7f8c8d',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: 'rgba(255,255,255,0.8)',
    borderRadius: 15,
    padding: 5,
    zIndex: 1000,
  },
});

export default MissionListScreen;